module.exports = __webpack_public_path__ + "static/media/3D5.02468dd7.png";